export type GenericEvent = {
    stopPropagation: () => void;
    preventDefault: () => void;
};

/**
 * Utility prevent event propagation and default action.
 * @param event Event to stop
 */
export function stopEvent(event: GenericEvent) {
    event.stopPropagation();
    event.preventDefault();
}

/**
 * Utility to wrap an event callback so that it does not perform default action or propagate.
 */
export function withStoppedEvent<TEvent extends GenericEvent, TReturn>(
    callback: (event: TEvent) => TReturn,
): (event: TEvent) => TReturn {
    return (event) => {
        stopEvent(event);
        return callback(event);
    };
}
